<style lang="scss" scoped>
.confirm-content {
    font-size: 16px;
    padding: 20px 0;
    text-align: center;
}
</style>
<template>
    <div class="clearfix" style="position: relative">
        <Form class="clearfix" :labelWidth="120" :model="formData" ref="myForm">
            <Col offset="3" span="30">
                <FormItem :label="$t('fbb.warehousemove.move_order_no', { defaultValue: '库存移库单号' })">
                    <span>{{this.orderNo}}</span>
                </FormItem>
            </Col>
            <Col offset="3" span="30">
                <FormItem :label="$t('global.common.notes', { defaultValue: '备注' })">
                    <Input
                        v-model="formData.remark"
                        type="textarea"
                    ></Input>
                </FormItem>
            </Col>
        </Form>
        <div class="pull-right padding-bottom-15 button-container">
            <Button type="primary" @click="submit">{{$t('global.common.update_OK', { defaultValue: '确定' })}}</Button>
            <Button class="margin-left-15" type="default" @click="cancel"
                >{{$t('global.common.operation_cancel', { defaultValue: '取消' })}}</Button
            >
        </div>
        <Spin v-if="loading" size="large" fix></Spin>
    </div>
</template>

<script>
import {
    HttpConfirmWarehouseMove,
    HttpAddRemark,
    HttpIgnoreComplete,
} from "@/service/warehousemove";
export default {
    props: ["type", "isOrder", "id","orderNo", "success", "otherParams"],
    data() {
        return {
            loading: false,
            required: {
                required: true,
                message: this.$t('fbb.headlogistics.info_empty', { defaultValue: '请填写必填项' }),
            },
            showRemark: true,
            formData: {
                pass: true
            },
        };
    },
    created() {
        console.log(this.id, this.otherParams);
        if (this.otherParams.noCommit) this.showRemark = false;
        if (this.otherParams.noRequired) this.required.required = false;
    },
    methods: {
        /**
         * 提交
         */
        async submit() {
            let flag = true;
            await this.$refs.myForm.validate((valid) => {
                flag = valid;
            });
            if (!flag) return;
            this.loading = true;
            let reqData = {
                id: this.id,
                ...this.formData,
            };
            let httpSubmit;
            // 销毁单
                switch (this.type) {
                    // 确认
                    case 4:
                        {
                            httpSubmit = HttpConfirmWarehouseMove(reqData);
                        }
                        break;
                    // 添加备注
                    case 10:
                        {
                            httpSubmit = HttpAddRemark(reqData);
                        }
                        break;
                        // 强制完成
                    case 5:
                        {
                            httpSubmit = HttpIgnoreComplete(reqData);
                        }
                        break;
                }
            httpSubmit
                .then(
                    (res) => {
                        this.$VMessage.success(res.message);
                        this.$emit("on-success");
                        this.$emit("on-update");
                        this.cancel();
                        if (this.success) {
                            console.log(this.success);
                            this.success();
                        }
                    },
                    (err) => {
                        this.$VMessage.error(err.message);
                    }
                )
                .finally(() => {
                    this.loading = false;
                });
        },
        cancel() {
            this.$emit("on-close");
        },
    },
};
</script>

<style>
</style>